import api from 'services/technical-visit/technical-visit'

export const handleGet = async (id: string) => {
  let res = await api.get(id)

  return res?.data?.data
}
